import { Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SN_API_URL } from '../../providers/api-url.provider';

@Component({
  selector: 'sn-connection-refused',
  templateUrl: './connection-refused.component.html',
  styleUrls: ['./connection-refused.component.scss'],
  host: {
    class: 'connection-error-layout',
  },
})
export class ConnectionRefusedComponent implements OnInit, OnDestroy {
  public readonly apiUrl: string;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(SN_API_URL) apiUrl: string,
    public httpClient: HttpClient,
    private readonly _router: Router,
  ) {
    this.apiUrl = apiUrl.replace(/(^\w+:|^)\/\//, '');
  }

  public ngOnInit(): void {
    setInterval(() => {
      this.goToMap();
    }, 30000);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public goToMap(): void {
    this._router.navigate(['/map']);
  }
}
